import React from "react";

export default function TimelineMain({ children }) {
  return <div className='timeline-block__main'>{children}</div>;
}
